import React, { useState } from 'react';
import { StyledSwitch } from './switchOnOffStyles';

interface ISwitchOnOffProps {
  isOnLight: boolean;
  onSwitch: (value: boolean) => void;
}
export const SwitchOnOff = ({ isOnLight, onSwitch }: ISwitchOnOffProps) => {
  const [isOn, setIsOn] = useState<boolean>(isOnLight);
  const handleSwitch = () => {
    setIsOn(!isOn);
    onSwitch(!isOn);
  };
  return <StyledSwitch checked={isOn} onChange={handleSwitch} />;
};
